module.exports = __webpack_public_path__ + "b5698b4998c497ea1f0c550d84354806.svg";